<template>
  <div class="content">
    <div class="title animate__animated" v-animate="'animate__bounceInDown'">
      <h2 class="Chinese">专注于年轻人群的广告营销</h2>
      <h4 class="English">Focus on advertising and marketing for young people</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBanner'
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 500px;
  width: 100%;
  background: url(~@/assets/images/24993962.jpg) repeat 50%;
  .title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 510px;
    height: 147px;
    border-radius: 16px;
    background-color: rgba(232, 100, 90, .9);
    transform: scale(1,1);
  }
}
</style>
